import { purry } from "./purry";
export function mapRecord() {
    return purry(_mapRecord(), arguments);
}
var _mapRecord = function () { return function (rec, fn) {
    return Object.entries(rec).map(function (_a) {
        var k = _a[0], v = _a[1];
        return fn([k, v]);
    }).reduce(function (acc, _a) {
        var k = _a[0], v = _a[1];
        acc[k] = v;
        return acc;
    }, {});
}; };
